var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiHappyColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15C8.70019 15 7.48106 14.2943 5.45639 13.8091C5.19413 13.7462 4.9681 14.0202 5.049 14.3058C5.98275 17.6022 8.73891 19.9936 12.0001 19.9936C15.2613 19.9936 18.0174 17.6022 18.9512 14.3058C19.0321 14.0202 18.8061 13.7462 18.5438 13.8091C16.519 14.2943 15.3 15 12.0001 15Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93541 10.7034C7.40094 10.7034 6.96767 10.2701 6.96767 9.73566V8.16774C6.96767 7.63327 7.40094 7.2 7.93541 7.2C8.46988 7.2 8.90314 7.63327 8.90314 8.16774V9.73566C8.90314 10.2701 8.46988 10.7034 7.93541 10.7034Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0644 10.7034C15.5299 10.7034 15.0967 10.2701 15.0967 9.73566V8.16774C15.0967 7.63327 15.5299 7.2 16.0644 7.2C16.5989 7.2 17.0321 7.63327 17.0321 8.16774V9.73566C17.0321 10.2701 16.5989 10.7034 16.0644 10.7034Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiHappyColored);
export default __webpack_public_path__ + "static/media/emoji-happy-colored.140d2eb979b4bfe9c755154da86cefce.svg";
export { ForwardRef as ReactComponent };